import { useDrag } from 'react-dnd';

const FruitItem = ({ fruit, onAdd }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'FRUIT',
    item: { name: fruit.name },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      style={{
        fontSize: '3rem',
        cursor: 'grab',
        userSelect: 'none',
        display: 'inline-block',
        margin: '0 12px',
        opacity: isDragging ? 0.5 : 1,
        border: '2px solid transparent',
        borderRadius: '50%',
        padding: '6px',
        transition: 'transform 0.2s ease, border-color 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.borderColor = '#7c3aed';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.borderColor = 'transparent';
      }}
      onClick={() => onAdd(fruit.name)}
      aria-label={`${fruit.name} fruit`}
      role="img"
      title={`${fruit.name} - ${fruit.price}€`}
    >
      {fruit.emoji}
      <div style={{ fontSize: '1rem', color: '#555', marginTop: '6px', textAlign: 'center' }}>
        {fruit.price}€
      </div>
    </div>
  );
};

export default FruitItem;
